<!--
  GuidePage.vue
    How to use guide page Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog
    v-model="mDialog"
    fullscreen
    hide-overlay
    transition="slide-x-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card dark color="primary" app class="hm-iphonex-notch">
        <v-btn icon color="primary" @click="hide">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t("settings.guide") }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text
       id="hm-guide-container"
       class="hm-guide-container"
      >
      <div class="hm-iphonex-notch">
        <div class="hm-guide-img hm-display-monitor">
          <img :src="this.mGuidPassWeb">
        </div>
        <div class="hm-guide-img hm-display-mobile">
          <img :src="this.mGuidPassApp">
        </div>
      </div>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { DOC_SERVER_URL, UM_GUIDE_IMG_WEB, UM_GUIDE_IMG_APP, formatDateMoment, getNowDatetimeMoment } from '@/common'

export default {
  name: 'GuidePage',
  data: () => ({
    mDialog: false,
    mGuidPassWeb: '',
    mGuidPassApp: '',
    mNowDateTime: ''
  }),
  mounted: function () {
    this.mNowDateTime = formatDateMoment(getNowDatetimeMoment(), 'YYYYMMDDHHmm')
    this.mGuidPassWeb = DOC_SERVER_URL + UM_GUIDE_IMG_WEB + '?' + this.mNowDateTime
    this.mGuidPassApp = DOC_SERVER_URL + UM_GUIDE_IMG_APP + '?' + this.mNowDateTime
    this.$log.debug('# GuidePage(' + this.mGuidPassWeb + ')')
    this.$on('show', this.show)
  },
  destroyed: function () {
    this.$log.debug('# GuidePage')
  },
  methods: {
    show: function () {
      this.$store.commit('setIsWhereaboutsPage', false)  // 行動予定一覧の更新を行わない
      this.mDialog = true  // Show Dialog
      this.$nextTick(() => {
        // DOM生成完了後に実行
        document.getElementById('hm-guide-container').scrollTop = 0
      })
    },
    hide: function () {
      this.$store.commit('setIsWhereaboutsPage', true)   // 行動予定一覧の更新を行う
      this.mDialog = false  // Close Dialog
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-guide-container {
  margin-top: 56px;
  text-align: center;
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .hm-guide-container {
    width: calc(100vw - 17px);
  }
}
.hm-guide-img {
  width: 90vw;
  max-width: 664px;
  min-width: 300px;
  margin: 10px auto;
  padding: 5px;
  border: 2px solid #8b0000;
  border-radius: 10px;
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/GuidePage.vue